<template>
  <div class="dashboard-container">
    <!-- 头部导航栏 -->
    <a-layout-header style="background: url('/assets/dpwDashboard/Dashboard_Banner_Bg2.png'); background-position: left 20px center; padding: 0; display: flex; justify-content: space-between; align-items: center; color: white;height: 90px">
    <div style="display: flex; align-items: center; margin-left: 20px;">
        <img src="/assets/dpwDashboard/dp_world_logo_white.png"  style="margin-right: 10px; width: 172px;height: 42px" />
      </div>
      <div style="display: flex; align-items: center; margin-right: 20px;">
        <img src="/assets/dpwDashboard/Dashboard_ecwms_logo_white.png"  style="margin-right: 10px;" />
        <span style="font-size: 24px">{{ $t("login.dashboardPortal") }}</span>
        <div class="outline-rounded-box" style="font-size: 16px"  @click="logout">{{ $t("login.signOut") }}
          <img src="/assets/dpwDashboard/dashboard_signout_icon.png"  style="width: 15px;height: 15px" />
        </div>

      </div>
    </a-layout-header>

    <!-- 主内容区 -->
    <a-layout-content style="padding: 20px; background: #fff; height: calc(100vh - 90px); overflow-y: auto;">
      <a-row :gutter="[20, 20]" style="height: 100%;">

        <a-col
            v-for="(card, index) in dashboardCards"
            :key="index"
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            :xl="8"
            style="height: calc(40vh - 20px);"
        >
          <div class="" style="height: 100%; display: flex; flex-direction: column;margin-left: 30px;margin-right: 30px">
            <!-- 图标 + 内容容器（标题 + 正文 + 按钮） -->
            <div style="display: flex; align-items: baseline; gap: 16px; padding: 12px 0;">
              <!-- 图标 -->
<!--              <a-icon type="appstore" style="font-size: 24px; color: #1a2b5f; flex-shrink: 0;" />-->
              <!-- 图标容器：固定行高对齐，限制最大尺寸 -->
              <div style="display: flex; align-items: center; flex-shrink: 0; max-width: 24px; max-height: 24px;">
                <img
                    :src="'/assets/dpwDashboard/' + card.iconName"
                    style="max-width: 100%; max-height: 100%; height: auto; width: auto; object-fit: contain;"
                    alt=""
                />
              </div>


              <!-- 内容区：标题 + 正文 + 按钮 -->
              <div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 8px;">
                <div style="font-weight: bold; font-size: 20px;">{{ card.reportName }}</div>
                <p style="line-height: 1.6; overflow-y: auto; margin: 0; font-size: 16px; flex: 1;color: #949494">
                  {{ card.reportDesc }}
                </p>
                <a-button type="default" @click="visitDashboard(card.reportUrl)"  style="width: fit-content; background:#E3E3E3;margin-top: 10px;">
                  {{ $t("login.view") }}
                </a-button>
              </div>
            </div>
          </div>
        </a-col>


        <!-- 第一行：三个卡片 -->
<!--        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="height: calc(40vh - 20px);">
          <div class="" style="height: 100%; display: flex; flex-direction: column;">
            &lt;!&ndash; 图标 + 内容容器（标题 + 正文 + 按钮） &ndash;&gt;
            <div style="display: flex; align-items: baseline; gap: 16px; padding: 12px 0;">
              &lt;!&ndash; 图标 &ndash;&gt;
              <a-icon type="appstore" style="font-size: 24px; color: #1a2b5f; flex-shrink: 0;" />

              &lt;!&ndash; 内容区：标题 + 正文 + 按钮 &ndash;&gt;
              <div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 8px;">
                <div style="font-weight: bold; font-size: 16px;">Inbound Overview</div>
                <p style="line-height: 1.6; overflow-y: auto; margin: 0; font-size: 14px; flex: 1;">
                  This dashboard streamlines visibility into inbound processes, empowering leaders to identify bottlenecks, enhance receiving throughput, and drive operational efficiency across the supply chain.
                </p>
                <a-button type="default" size="small" style="width: fit-content; background:#E3E3E3;margin-top: 10px ">View</a-button>
              </div>
            </div>
          </div>
        </a-col>

        -->
      </a-row>
    </a-layout-content>
  </div>
</template>

<script>
    import ajax from "@/api/ajax";
    import api from "@/api/url";
    import sessionManager from "@/utils/session-manager";

    export default {
        name: 'Dashboard',
        data() {
          return {
            dashboardCards: []
          }
        },
        mounted() {
            this.adjustImageSize();  // 在组件挂载后调用调整图片的函数
            window.addEventListener("resize", this.adjustImageSize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.adjustImageSize);  // 清理事件监听
        },
        created() {
          this.init()
        },
        methods: {
            adjustImageSize() {
                const image = document.getElementById("responsiveImage");
                if (!image) return;  // 防止 null 错误

                if (window.innerWidth <= 768) {
                    // 在手机端，图片高度和宽度都占满屏幕
                    image.style.width = "100vw";
                    image.style.height = "100vh";
                    image.style.objectFit = "cover";
                } else {
                    // 在桌面端，保持原有的比例
                    image.style.width = "auto";
                    image.style.height = "100%";
                    image.style.objectFit = "contain";
                }
            },

          init() {
            let languageSelect = this.languageSelectChange(this.$i18n.locale);

            let params = {
              language: languageSelect,
            };

            ajax.post(api.INVENTORYDPWDASHBOARDINFO, params).then(res => {
              if (res.code == 200) {
                let returnData = res.data;
                if(null == returnData || returnData.length == 0) {
                  return;
                }

                this.dashboardCards = returnData;


              } else {
                this.$customMessage.warning(res.msg, 3);
              }
            });
          },


          languageSelectChange(language) {
              let returnLanguage = '';

              if(language == 'zh') {
                returnLanguage = '简体中文 / S. Chinese';
              } else if (language == 'zh_tw') {
                returnLanguage = '繁體中文 / T. Chinese';
              } else if (language == 'kor') {
                returnLanguage = '한국어 / Korean';
              } else if (language == 'jp') {
                returnLanguage = '日本語 / Japanese';
              } else {
                returnLanguage = 'English';
              }

              return returnLanguage;
          },
          visitDashboard(url) {
            this.$router.push({
              path: "/dashboard/report",
              query: {
                url: url
              }
            });
          },
          logout() {
            ajax.get(api.USERLOGOUTLOGINACCOUNT).then(res=>{
              sessionManager.clearUserData();
              this.$router.push({path: "/dashboard/login"})
              this.leftMenuActive = '0'
            })
          },


        }
    };
</script>

<style scoped>
.outline-rounded-box {
  border: 1px solid #fff;
  border-radius: 12px;
  margin: 20px;
  height: 40px;
  line-height: 40px;
  width: 120px;
  text-align: center;
}
.dashboard-container {
  min-height: 100vh;
}

.dashboard-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dashboard-card .ant-card-head-title {
  font-size: 16px;
  font-weight: bold;
}

.dashboard-card p {
  margin: 12px 0;
  font-size: 14px;
  color: #555;
}

.dashboard-card .ant-btn {
  margin-top: 10px;
}

    .custom-button:hover  span {
        color: #56b8e1 !important; /* 悬停时子元素字体颜色 */
    }

    .container {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .image {
        max-height: 100%;
        width: auto;
        object-fit: contain;
    }
</style>
